import type { GovButtonProps } from '@gov-design-system-ce/react/gov-button';
import { GovButton } from '@gov-design-system-ce/react/gov-button';
import { Icon } from '../Icon/Icon';

export interface FormButtonProps extends Omit<
	GovButtonProps,
	'loading' | 'disabled' | 'isExpanded'
> {
	isLoading?: boolean;
	isDisabled?: boolean;
	isExpanded?: boolean;
	isExpandedMobile?: boolean;
	isFocusable?: boolean;
	isDownload?: boolean;
	title?: string;
}

export const Button = ({
	children,
	isLoading = false,
	isDisabled = false,
	isExpanded,
	isExpandedMobile,
	isFocusable = true,
	isDownload,
	...props
}: FormButtonProps) => (
	<GovButton
		loading={isLoading ? 'true' : 'false'}
		iconStart={
			isLoading ? (
				<Icon
					className="gov-loading__icon gov-spin-animation"
					name="loader"
					type="components"
				/>
			) : (
				props.iconStart
			)
		}
		disabled={isDisabled || isLoading}
		expanded={isExpanded}
		expandedMobile={isExpandedMobile}
		tabIndex={isFocusable ? 0 : -1}
		{...props}>
		{children}
	</GovButton>
);
